// OGC Teams page interactions
(function(){
(function () {
    var els = document.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(function(el){ el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  })();

  // Hero mockup: fly the profile + analytics in only once the user scrolls.
  // The dashboard sits above the fold, so we gate on an actual scroll action
  // rather than initial visibility.
  (function () {
    var stack = document.querySelector('.td-stack');
    if (!stack) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      stack.classList.add('is-visible');
      return;
    }
    function onScroll() {
      if (window.scrollY > 40) {
        stack.classList.add('is-visible');
        window.removeEventListener('scroll', onScroll);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  // Testimonial carousel scroll buttons
  (function () {
    var carousel = document.querySelector('.testimonial-carousel');
    if (!carousel) return;
    var track = carousel.querySelector('.testimonial-scroll');
    var prev = carousel.querySelector('.tcard-nav.prev');
    var next = carousel.querySelector('.tcard-nav.next');
    if (!track || !prev || !next) return;

    function scrollAmount() {
      var card = track.firstElementChild;
      var gap = 20;
      return card ? card.offsetWidth + gap : track.clientWidth * 0.8;
    }
    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  })();

  // Profile showcase carousel scroll buttons
  (function () {
    var carousel = document.querySelector('.profiles-carousel');
    if (!carousel) return;
    var track = carousel.querySelector('.profiles-row');
    var prev = carousel.querySelector('.pcard-nav.prev');
    var next = carousel.querySelector('.pcard-nav.next');
    if (!track || !prev || !next) return;

    function scrollAmount() {
      var card = track.firstElementChild;
      var gap = 20;
      return card ? (card.offsetWidth + gap) * 2 : track.clientWidth * 0.8;
    }
    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  })();

  // ── Demo lead-gen modal ──
  (function () {
    // Unlisted YouTube video ID — replace with the real one once uploaded.
    var YOUTUBE_VIDEO_ID = 'SWaBDAS9KHE';

    var modal   = document.getElementById('demoModal');
    var dialog  = document.getElementById('demoDialog');
    var form    = document.getElementById('demoForm');
    var frame   = document.getElementById('demoVideoFrame');
    var closeEl = document.getElementById('demoClose');
    if (!modal || !form) return;

    var lastFocused = null;

    function openModal() {
      lastFocused = document.activeElement;
      modal.classList.add('is-open');
      document.body.classList.add('demo-modal-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var first = form.querySelector('input, select');
      if (first) setTimeout(function () { first.focus(); }, 60);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('demo-modal-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Stop playback by clearing the iframe when closed
      if (frame) frame.innerHTML = '';
      dialog.classList.remove('show-video');
      if (lastFocused) lastFocused.focus();
    }

    // Open from any element flagged with data-demo-open (the hero "Watch Demo")
    document.querySelectorAll('[data-demo-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();

        if (localStorage.getItem('ogcDemoUnlocked') === 'true') {
          playDemoVideo();
        }
      });
    });

    closeEl.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    function playDemoVideo() {
      frame.innerHTML =
        '<iframe src="https://www.youtube-nocookie.com/embed/' + YOUTUBE_VIDEO_ID +
        '?autoplay=1&rel=0&playsinline=1&cc_load_policy=0" title="One Good Card for Teams demo" ' +
        'allow="autoplay; encrypted-media; picture-in-picture; web-share" ' +
        'allowfullscreen></iframe>';

      dialog.classList.add('show-video');
    }

    form.addEventListener('submit', function (e) {
      if (!form.checkValidity()) {
        e.preventDefault();
        form.reportValidity();
        return;
      }

      localStorage.setItem('ogcDemoUnlocked', 'true');
    });

    if (window.location.search.indexOf('demo_submitted=true') > -1) {
      localStorage.setItem('ogcDemoUnlocked', 'true');
      openModal();
      playDemoVideo();

      if (history.replaceState) {
        history.replaceState(null, '', window.location.pathname);
      }
    }
  })();

if (window.lucide) { lucide.createIcons(); }
})();
